export const colors = {
  primary: {
    50: '#F4F7FF',
    100: '#EEF1FA',
    200: '#C8D1F3',
    300: '#A3B1E8',
    400: '#7B8FDB',
    500: '#5D75D1',
    600: '#3D57BB',
    700: '#233166',
    800: '#1A2650',
    900: '#111A38',
  },

  accent: {
    50: '#FCEFF0',
    100: '#FAE0E0',
    200: '#F5C1C1',
    300: '#EFA2A3',
    400: '#EA8384',
    500: '#E56465',
    600: '#B75051',
    700: '#893C3D',
    800: '#5C2828',
    900: '#2E1414',
  },

  neutral: {
    20: '#F7F7F5',
    50: '#F2F2F2',
    100: '#E5E5E5',
    200: '#CCCCCC',
    300: '#B2B2B2',
    400: '#999999',
    500: '#808080',
    600: '#666666',
    700: '#4D4D4D',
    800: '#333333',
    900: '#1A1A1A',
  },

  grey: {
    100: '#F5F5F4',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },

  darkBlue: {
    1: '#2434BC',
    2: '#4D66D6',
    3: '#3B52BD',
    4: '#31446E',
    5: '#2C3F70',
    6: '#1B274A',
    7: '#16213F',
    8: '#101A33',
    9: '#0A1224',
  },

  success: {
    100: '#E6F7EE',
    200: '#BEECD4',
    300: '#88D9AE',
    400: '#55C285',
    500: '#2E9E60',
    600: '#217A49',
    700: '#175E37',
    800: '#0E4426',
    900: '#082D18',
  },

  error: {
    100: '#FEF0F0',
    200: '#FCCFCF',
    300: '#F9A3A3',
    400: '#F27070',
    500: '#E03B3B',
    600: '#C42828',
    700: '#A31E1E',
    800: '#7E1414',
    900: '#560C0C',
  },

  warning: {
    100: '#FEF4E8',
    200: '#FDE0BC',
    300: '#FAC484',
    400: '#F5A04A',
    500: '#E07C1A',
    600: '#C46210',
    700: '#A04C0A',
    800: '#7A3806',
    900: '#522602',
  },

  info: {
    100: '#E8F2FD',
    200: '#C2DBFA',
    300: '#8DBFF5',
    400: '#5699EE',
    500: '#2C7BE5',
    600: '#1A62CC',
    700: '#1049A8',
    800: '#0A3382',
    900: '#062158',
  },

  violet: {
    100: '#F4F2FF',
    200: '#E8E4FF',
    300: '#D2CBFA',
    400: '#B7AEF2',
    500: '#8B7FE8',
    600: '#7467D1',
    700: '#5E53B5',
    800: '#4A4097',
    900: '#38317A',
  },

  green: {
    100: '#E8F8F0',
    200: '#C2ECDA',
    300: '#90D9BA',
    400: '#61C49A',
    500: '#4CAF82',
    600: '#389968',
    700: '#277A50',
    800: '#185C3A',
    900: '#0C3F26',
  },

  teal: {
    100: '#EFF9F8',
    200: '#D6F0EF',
    300: '#AFDEDE',
    400: '#84CECB',
    500: '#5BBAB8',
    600: '#328B89',
    700: '#28716F',
    800: '#205A59',
    900: '#194645',
  },

  rose: {
    100: '#FFF1F1',
    200: '#FBE2E2',
    300: '#F5C7C7',
    400: '#EDAAAA',
    500: '#D98989',
    600: '#BC6F6F',
    700: '#9A5959',
    800: '#7A4545',
    900: '#5D2525',
  },

  amber: {
    100: '#FEF9E7',
    200: '#FDEFC0',
    300: '#FAE088',
    400: '#F5CB47',
    500: '#E6A817',
    600: '#C48A0C',
    700: '#9E6D07',
    800: '#785204',
    900: '#523802',
  },

  white: '#FFFFFF',
  black: '#000000',
  default: '#C4C4C4',
} as const;

export type Colors = typeof colors;
